module.exports = __webpack_public_path__ + "static/img/img4.07e5a251.png";